/*jshint esversion: 8 */
import React, { Component } from 'react';
// import clsx from  'clsx';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';

import SettingsIcon from '@material-ui/icons/Settings';
import HouseIcon from '@material-ui/icons/House';
import PaymentIcon from '@material-ui/icons/Payment';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { green } from '@material-ui/core/colors';
import Collapse from '@material-ui/core/Collapse';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Person from '@material-ui/icons/Person';
import store from './stores/Store';
import { getIfFuncAuthorized } from '../utils/CheckSomething';
import { clearLocalStorage } from '../utils/LocalStorageHandler';
import { loginType, hostName } from "../config/ips";

const styles = {
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: green,
  },
  root_mobile: {
    position: 'fixed',
    bottom: '0.5rem',
    left: '0rem',
  },
  list: {
    width: '250px',
  },
  button: {
    marginTop: '0.5rem',
    marginLeft: '0.5rem',
    backgroundColor: '#FFF',
    opacity: '1',
    '&:hover': {
      opacity: '0.9',
      background: 'white',
    },
  },
  nested: {
    paddingLeft: '50px',
  },
};
// NavigateLeft
class NaviLeftInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
      openState: {
        systemManagement: true,
        ticketManagement: true,
        tradeManagement: true,
      }
    };
    this.handleListItemClick = this.handleListItemClick.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleRouter = this.handleRouter.bind(this);
  }

  componentDidMount() { }
  componentWillUnmount() { }

  handleListItemClick(e, num) {
    console.log(e, num);
  }

  handleRouter(e, text) {
    console.log(e, text);
  }

  handleOpen(e, num) {
    this.setState({
      openState: {
        ...this.state.openState,
        [num]: !this.state.openState[num],
      }
    });
  }

  handleLogin(e) {
    console.log(`----- handleLogin`);
    this.setState({ login: true });
  }

  handleLogout(e) {
    console.log(`----- handleLogout`);
    store.userExist();
    clearLocalStorage();
  }

  render() {
    const { classes } = this.props;
    if (!store.user.logined) {
      return (
        <div className={classes.root}>
          <List component="nav" aria-label="secondary mailbox folder">
            <ListItem
              button
              component={Link} to={{ pathname: '/login' }}>
              <ListItemIcon>
                <ExitToApp />
              </ListItemIcon>
              <ListItemText primary="登录" />
            </ListItem>
          </List>
        </div>
      );

    }
    return (
      <div className={classes.root}>
        <List component="nav" aria-label="">
          <ListItem>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText >
              {`${hostName}房票系统`}
              <br />
              {`${store.user.rolename}`}
              <br />
              {`${store.user.memname}`}
            </ListItemText>
          </ListItem>
          {
            (getIfFuncAuthorized('系统管理')) &&
            (<ListItem
              button
              hidden
              onClick={(event) => this.handleOpen(event, 'systemManagement')}
            >
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="系统管理" />
              {this.state.openState['systemManagement'] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>)
          }
          <Collapse in={this.state.openState.systemManagement} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {getIfFuncAuthorized('系统管理-市场管理')
                &&
                (
                  <ListItem
                    button
                    component={Link} to={{ pathname: '/SystemManagement/marketManagement' }}
                    className={classes.nested}
                  >
                    <ListItemText primary="市场管理" />
                  </ListItem>
                )
              }
              {getIfFuncAuthorized('系统管理-用户管理')
                &&
                (
                  <ListItem
                    button
                    component={Link} to={{ pathname: '/systemManagement/userManagement' }}
                    className={classes.nested}
                  >
                    <ListItemText primary="用户管理" />
                  </ListItem>
                )
              }
              {getIfFuncAuthorized('系统管理-权限管理')
                &&
                (
                  <ListItem
                    button
                    component={Link} to={{ pathname: '/systemManagement/authorizationManagement' }}
                    className={classes.nested}
                  >
                    <ListItemText primary="权限管理" />
                  </ListItem>
                )
              }
            </List>
          </Collapse>
          {getIfFuncAuthorized('系统管理') && (<Divider />)}

          {getIfFuncAuthorized('房票管理')
            && (
              <ListItem
                button
                onClick={(event) => this.handleOpen(event, 'ticketManagement')}
              >
                <ListItemIcon>
                  <HouseIcon />
                </ListItemIcon>
                <ListItemText primary="房票管理" />
                {this.state.openState.ticketManagement ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )
          }
        </List>
        <Collapse in={this.state.openState.ticketManagement} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {getIfFuncAuthorized('房票管理-房票信息管理')
              && (
                <ListItem
                  button
                  component={Link} to={{ pathname: '/RoomTicketManagement/TicketInfoManagement' }}
                  className={classes.nested}
                >
                  <ListItemText primary="房票信息管理" />
                </ListItem>
              )
            }
            {getIfFuncAuthorized('房票管理-开发商管理')
              &&
              (
                <ListItem
                  button
                  component={Link} to={{ pathname: '/DeveloperManagement/DeveloperManagement' }}
                  className={classes.nested}>
                  <ListItemText primary="开发商管理" />
                </ListItem>
              )
            }
            {getIfFuncAuthorized('房票管理-开发商用户管理')
              &&
              (
                <ListItem
                  button
                  component={Link} to={{ pathname: '/DeveloperUserManagement/DeveloperUserManagement' }}
                  className={classes.nested}>
                  <ListItemText primary="开发商用户管理" />
                </ListItem>
              )
            }
            {getIfFuncAuthorized('房票管理-开发商房源管理')
              &&
              (
                <ListItem
                  button
                  component={Link} to={{ pathname: '/RoomManagement/RoomManagement' }}
                  className={classes.nested}>
                  <ListItemText primary="开发商房源管理" />
                </ListItem>
              )
            }
          </List>
        </Collapse>
        {getIfFuncAuthorized('房票管理') && (<Divider />)}
        {
          ((getIfFuncAuthorized('安居房管理'))) &&
            (<ListItem
              button
              hidden
              onClick={(event) => this.handleOpen(event, 'comfortableHousingManagement')}
            >
              <ListItemIcon>
                <HouseIcon />
              </ListItemIcon>
              <ListItemText primary="安居房管理" />
              {this.state.openState['comfortableHousingManagement'] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>)
        }
        <Collapse in={this.state.openState.comfortableHousingManagement} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {(getIfFuncAuthorized('安居房管理-安置房住户明细表'))
              &&
              (
                <ListItem
                  button
                  component={Link} to={{ pathname: '/ComfortableHousingManagement/ComfortableHousingTable' }}
                  className={classes.nested}
                >
                  <ListItemText primary="安置房住户明细表" />
                </ListItem>
              )
            }
            {(getIfFuncAuthorized('安居房管理-安置房住户明细表'))
              &&
              (
                <ListItem
                  button
                  component={Link} to={{ pathname: '/ComfortableHousingManagement/Statistics' }}
                  className={classes.nested}
                >
                  <ListItemText primary="安置房信息统计" />
                </ListItem>
              )
            }
          </List>
        </Collapse>
        {getIfFuncAuthorized('房票管理') && (<Divider />)}
        <List component="nav" aria-label="secondary mailbox folder">
          {getIfFuncAuthorized('交易管理')
            &&
            (
              <ListItem
                button
                onClick={(event) => this.handleOpen(event, 'tradeManagement')}
              >
                <ListItemIcon>
                  <PaymentIcon />
                </ListItemIcon>
                <ListItemText primary="交易管理" />
                {this.state.openState.tradeManagement ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )
          }
        </List>
        <Collapse in={this.state.openState.tradeManagement} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {getIfFuncAuthorized('交易管理-交易记录管理')
              &&
              (
                <ListItem
                  button
                  component={Link} to={{ pathname: '/TradeManagement/OrderManagement' }}
                  className={classes.nested}
                >
                  <ListItemText primary="交易记录管理" />
                </ListItem>
              )
            }
            {getIfFuncAuthorized('交易管理-交易记录统计')
              &&
              (
                <ListItem
                  button
                  component={Link} to={{ pathname: '/TradeManagement/TradeStatistics' }}
                  className={classes.nested}
                >
                  <ListItemText primary="交易记录统计" />
                </ListItem>
              )
            }
          </List>
        </Collapse>
        {getIfFuncAuthorized('交易管理') && (<Divider />)}

        {
          loginType === 'password'
          && store.user.logined
          && getIfFuncAuthorized("个人信息维护")
          &&
          (
            <ListItem
              button
              component={Link} to={{ pathname: '/systemManagement/userInfoManagement' }}
            >
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="个人信息维护" />
            </ListItem>
          )
        }
        {store.user.logined && (
          <List component="nav" aria-label="secondary mailbox folder">
            <ListItem
              button
              onClick={(event) => this.handleLogout(event)}
              component={Link} to={{ pathname: '/' }}
            >
              <ListItemIcon>
                <ExitToApp />
              </ListItemIcon>
              <ListItemText primary="退出" />
            </ListItem>
          </List>)}
        {!store.user.logined && (
          <List component="nav" aria-label="secondary mailbox folder">
            <ListItem
              button
              onClick={(event) => this.handleLogin(event)}
            >
              <ListItemIcon>
                <ExitToApp />
              </ListItemIcon>
              <ListItemText primary="登录" />
            </ListItem>
          </List>
        )}
      </div>
    );
  }
}

const NaviLeft = observer(NaviLeftInner);

NaviLeft.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NaviLeft);